import React from 'react';
import { useWizard } from '../useWizard';
import OperatingHoursForm from '../forms/OperatingHoursForm';
import { WIZARD_STEPS } from '../../../types/wizard';

const OperatingHoursStep: React.FC = () => {
  const { state, stepErrors, updateOperatingHour, copyMondayToWeekdays } = useWizard();
  const errors = stepErrors[WIZARD_STEPS.HOURS] || {};

  return (
    <div className="wizard-step">
      <h2>Operating Hours</h2>
      <p className="step-description">
        Set the clinic's operating hours. Hours default to Monday&ndash;Friday, 8:00 AM&ndash;5:00 PM
        &mdash; adjust below if the clinic keeps a different schedule.
      </p>

      <OperatingHoursForm
        hours={state.operatingHours}
        onUpdateHour={updateOperatingHour}
        onCopyToWeekdays={copyMondayToWeekdays}
        errors={errors}
      />
    </div>
  );
};

export default OperatingHoursStep;
